import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 20000,
});

export const searchUSDA = async (query, pageSize = 15) => {
  const { data } = await api.get(`/usda/search`, { params: { query, page_size: pageSize } });
  return data;
};

export const searchSwiss = async (query, pageSize = 15) => {
  const { data } = await api.get(`/swiss/search`, { params: { query, page_size: pageSize } });
  return data;
};

export const listRecipes = async () => {
  const { data } = await api.get(`/recipes`);
  return data;
};

export const getRecipe = async (id) => {
  const { data } = await api.get(`/recipes/${id}`);
  return data;
};

export const createRecipe = async (payload) => {
  const { data } = await api.post(`/recipes`, payload);
  return data;
};

export const updateRecipe = async (id, payload) => {
  const { data } = await api.put(`/recipes/${id}`, payload);
  return data;
};

export const deleteRecipe = async (id) => {
  const { data } = await api.delete(`/recipes/${id}`);
  return data;
};

export const listCustomIngredients = async () => {
  const { data } = await api.get(`/integration/custom-ingredients`);
  return data;
};

export const saveCustomIngredient = async (payload) => {
  const { data } = await api.post(`/integration/custom-ingredients`, payload);
  return data;
};

export const deleteCustomIngredient = async (id) => {
  const { data } = await api.delete(`/integration/custom-ingredients/${id}`);
  return data;
};
